import {useAppSelector} from '../../store/hooks';
import {RootState} from '../../store/store';
import Container from '../common/layout/Container';
import EditUserProfile from './EditUserProfile';
import EditUserEmail from './EditUserEmail';
import {currentUserProps} from '../../store/currentUser/currentUser.slice';
import Tabs from '../common/Tabs';
import {Route, Switch, useRouteMatch} from 'react-router-dom';
import {MatchParams} from '../../constants/types';
import UnsortableList from '../common/UnsortableList';
import {useTranslation} from 'react-i18next';

const getTabs = (path: string, tabLabels) => ([
  {
    name: tabLabels.account,
    link: path,
    permissions: null
  },
  {
    name: tabLabels.email,
    link: `${path}/email`,
    permissions: null
  },
  {
    name: tabLabels.groups,
    link: `${path}/groups`,
    permissions: null
  }
]);

const UserProfile = () => {
  const {t} = useTranslation('user');
  const {url, path}: MatchParams = useRouteMatch();
  const currentUser: currentUserProps = useAppSelector(
      (state: RootState) => state.user
  );
  const {id, firstName, lastName} = currentUser || {};

  const userName = firstName && lastName ? `${firstName} ${lastName}` : '';

  const tabLabels = {
    account: t('profile.tabs.account.label'),
    email: t('profile.tabs.email.label'),
    groups: t('profile.tabs.groups.label')
  };

  return (
    <Container header={t('profile.header')}>
      <div className="user-profile">
        <h2 className="subheader">
          {t('profile.subheader', {userName})}
        </h2>

        <Tabs tabs={getTabs(url, tabLabels)} />

        <Switch>
          <Route exact path={url}>
            <EditUserProfile />
          </Route>

          <Route exact path={`${url}/email`}>
            <EditUserEmail />
          </Route>

          <Route exact path={`${url}/groups`}>
            <UnsortableList
              id={id}
              name={userName}
              entityKey={`${path}/groups`}
            />
          </Route>
        </Switch>
      </div>
    </Container>
  );
};

export default UserProfile;
